import React from 'react';
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { INewsItem } from '../../models/INewsItem';
import { LastReadProduct } from './LastReadProduct';
import { Recommendations } from './Recommendations';
import { News } from '../news/News';
import { DeploymentType, SourceApp } from '../../../Config';

export interface IProps {
    store: ManningOnlineStore;
    news: INewsItem[];
    deploymentType: DeploymentType;
    sourceApp: SourceApp;
}
export interface IState {
    reccomendationsData: any;
}

export class ForYou extends React.Component <IProps, IState> {
    
    constructor(props: IProps) {
        super(props);
    }

    public render(){
        return <div className="for-you-root">
                    <Recommendations sourceApp={this.props.sourceApp} deploymentType={this.props.deploymentType} />

                    <div className='for-you-meap-updates'>what's new</div>
                    <News news={this.props.store.catalogState.news}
                          store={this.props.store}/>
               </div>
    }
}